var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52.367,
    height: 42.699,
    viewBox: "0 0 52.367 42.699",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M4.90942 0C2.19897 0 0 2.39069 0 5.33737C0 7.01642 0.726196 8.59537 1.96375 9.60727C1.96375 9.60727 24.2196 27.7543 24.2196 27.7543C25.3855 28.6995 26.9811 28.6995 28.1471 27.7543C28.1471 27.7543 50.4028 9.60727 50.4028 9.60727C51.6404 8.59537 52.3666 7.01642 52.3666 5.33737C52.3666 2.39069 50.1676 0 47.4573 0C47.4573 0 4.90942 0 4.90942 0C4.90942 0 4.90942 0 4.90942 0ZM0 12.4537C0 12.4537 0 35.5823 0 35.5823C0 39.5074 2.93542 42.6988 6.54578 42.6988C6.54578 42.6988 45.8208 42.6988 45.8208 42.6988C49.4312 42.6988 52.3666 39.5074 52.3666 35.5823C52.3666 35.5823 52.3666 12.4537 52.3666 12.4537C52.3666 12.4537 30.1108 30.6007 30.1108 30.6007C27.7788 32.5022 24.5878 32.5022 22.2559 30.6007C22.2559 30.6007 0 12.4537 0 12.4537L0 12.4537Z",
    fill: "#45663B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.6f06099bd9a75944daed64e92fa0525d.svg";
export { ForwardRef as ReactComponent };